import React, { useEffect } from "react";
import "./Dashboard.css";
import profileimg from "../../../src/assets/img/brand/chat-user-image.png";
import img1 from "../../assets/img/img1.webp";
import img2 from "../../assets/img/img2.webp";
import img3 from "../../assets/img/img3.webp";
import img4 from "../../assets/img/img4.webp";
import { useHistory } from "react-router-dom";
import arrow from "../../assets/img/arrow.png";
import { useDispatch, useSelector } from "react-redux";

const Dashboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user, loading, userLanguage } = useSelector((state) => state.auth);
  const { translationState } = useSelector((state) => state.user);

  const shippingCartTranslation =
    translationState?.[0]?.translations?.shippingCart?.[userLanguage];
  const dashboardTranslation =
    translationState?.[0]?.translations?.dashboard?.[userLanguage];
  const otherOrderTranslation =
    translationState?.[0]?.translations?.otherOrder?.[userLanguage];

  return (
    <>
      {loading ? (
        <div style={{ textAlign: "center", margin: "240px" }}>
          <i
            className="fas fa-spinner fa-pulse fa-2x"
            style={{ color: "green" }}
          ></i>
        </div>
      ) : (
        <>
          <div className="mt-5 ">
            <div className="first-div">
              <div className="row">
                <img
                  className=" border border-dark rounded-circle"
                  style={{ height: "50px", width: "50px" }}
                  src={user.profileAvatar ? user.profileAvatar : profileimg}
                />
                <div className="mx-3 mt-3">
                  <h4>
                    <b>
                      {user.firstname} {user.lastname}
                    </b>
                  </h4>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-6">
                  <h5 className="adress-text">
                    {shippingCartTranslation?.shippingAddress
                      ? `${shippingCartTranslation?.shippingAddress}: `
                      : "Shipping Address: "}
                  </h5>
                </div>
                <div className="col-6">
                  <h5 className="adress-text">
                    {dashboardTranslation?.billing
                      ? `${dashboardTranslation?.billing}: `
                      : "Billing Address: "}
                  </h5>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  {user.billingAddress && (
                    <div>
                      {user.billingAddress?.streetname}
                      <br />
                      {user.billingAddress?.cityname},{" "}
                      {user.billingAddress?.country}{" "}
                      {user.billingAddress?.zipcode}
                    </div>
                  )}
                </div>
                <div className="col-6">
                  {user.shippingAddress && (
                    <div>
                      {user.shippingAddress?.streetname}
                      <br />
                      {user.shippingAddress?.cityname},{" "}
                      {user.shippingAddress?.country}{" "}
                      {user.shippingAddress?.zipcode}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="second-div">
            <div className="row row-setting justify-content-between">
              <div>
                <h4 className="">
                  <b>
                    {dashboardTranslation?.myOrder
                      ? dashboardTranslation?.myOrder
                      : "My Orders"}
                  </b>
                </h4>
              </div>
              <div
                className="pointer-cursor-top"
                onClick={() => history.push("/customer-account/orders")}
              >
                {dashboardTranslation?.viewAll
                  ? dashboardTranslation?.viewAll
                  : "View all"}
                <img
                  src={arrow}
                  style={{ height: "10px", width: "10px", marginLeft: "10px" }}
                />
              </div>
            </div>
            <div className="row  row-setting">
              <div
                onClick={() =>
                  history.push("/customer-account/orders?type=unpaid")
                }
                className="col-xl-3  col-6   pointer-cursor"
              >
                <img
                  className="my-3 user-dashboard-icons"
                  width="60px"
                  src={img1}
                />
                <p>
                  {dashboardTranslation?.unpaid
                    ? dashboardTranslation?.unpaid
                    : "Unpaid"}
                </p>
              </div>
              <div
                onClick={() =>
                  history.push("/customer-account/orders?type=toShip")
                }
                className="col-xl-3  col-6  pointer-cursor"
              >
                <img
                  className="my-3 user-dashboard-icons"
                  width="60px"
                  src={img2}
                />
                <p>
                  {dashboardTranslation?.toBeShipped
                    ? dashboardTranslation?.toBeShipped
                    : "To be shipped"}
                </p>
              </div>
              <div
                onClick={() =>
                  history.push("/customer-account/orders?type=shipped")
                }
                className="col-xl-3 col-6  pointer-cursor"
              >
                <img
                  className="my-3 user-dashboard-icons"
                  width="60px"
                  src={img3}
                />
                <p>
                  {otherOrderTranslation?.shipped
                    ? otherOrderTranslation?.shipped
                    : "Shipped"}
                </p>
              </div>
              <div
                onClick={() =>
                  history.push("/customer-account/orders?type=toReview")
                }
                className="col-xl-3  col-6  pointer-cursor"
              >
                <img
                  className="my-3 user-dashboard-icons"
                  width="60px"
                  src={img4}
                />
                <p>
                  {dashboardTranslation?.toBeReviewed
                    ? dashboardTranslation?.toBeReviewed
                    : "To be reviewed"}
                </p>
              </div>
            </div>
            <div className="my-2 row row-setting justify-content-between botton-nav-row">
              <div className="row align-items-center">
                <svg
                  viewBox="0 0 1024 1024"
                  width="2em"
                  height="2em"
                  fill="currentColor"
                  aria-hidden="false"
                  focusable="false"
                >
                  <path d="M792.661333 138.666667C848.746667 138.666667 896 179.178667 896 231.829333v66.56h-64v-66.56c0-14.933333-16.597333-29.162667-39.338667-29.162666H231.338667C208.64 202.666667 192 216.917333 192 231.829333v581.674667c0 14.912 16.64 29.162667 39.338667 29.162667h561.322666c22.72 0 39.338667-14.250667 39.338667-29.162667V554.666667h64v258.837333c0 52.629333-47.274667 93.162667-103.338667 93.162667H231.338667C175.296 906.666667 128 866.133333 128 813.504V231.829333C128 179.178667 175.274667 138.666667 231.338667 138.666667z m77.248 235.690666l15.872 15.872c8.746667 8.789333 8.746667 22.976 0 31.765334L564.778667 742.997333l-68.650667 28.394667a5.632 5.632 0 0 1-7.36-7.338667l28.373333-68.693333 321.002667-321.002667a22.442667 22.442667 0 0 1 31.765333 0zM512 522.666667v64h-192v-64h192z m128-192v64H320v-64h320z"></path>
                </svg>
                <b style={{ marginLeft: "8px" }}>
                  {dashboardTranslation?.supportTicket
                    ? dashboardTranslation?.supportTicket
                    : "Support Tickets"}
                </b>
              </div>
              <div
                onClick={() =>
                  history.push("/customer-account/seller-support-tickets")
                }
                className=" pointer-cursor"
              >
                <img src={arrow} style={{ height: "15px", width: "15px" }} />
              </div>
            </div>
            <div className="row justify-content-between botton-nav-row">
              <div className="row align-items-center">
                <svg
                  viewBox="0 0 1024 1024"
                  width="2em"
                  height="2em"
                  fill="currentColor"
                  aria-hidden="false"
                  focusable="false"
                >
                  <path d="M555.413333 87.488l7.573334 0.832c196.394667 23.061333 353.984 182.912 373.546666 380.266667 26.666667 269.696-198.250667 494.634667-467.946666 467.925333-199.893333-19.797333-361.301333-181.205333-381.098667-381.098667C60.8 285.738667 285.738667 60.8 555.413333 87.488zM151.168 549.12c16.810667 169.514667 154.197333 306.922667 323.733333 323.712 229.504 22.72 420.650667-168.426667 397.930667-397.930667-16.554667-167.082667-150.229333-302.933333-316.373333-322.922666l-7.338667-0.789334-6.869333-0.64C315.818667 132.309333 128.682667 321.92 151.168 549.12z m392.853333-307.669333v76.970666a200.384 200.384 0 0 1 119.744 63.488l-47.466666 42.944c-23.338667-25.792-56.469333-41.92-93.034667-44.330666-40.042667-2.666667-75.733333 7.402667-96.725333 28.074666-5.418667 5.333333-9.770667 14.805333-10.410667 23.552-0.618667 8.618667 1.365333 14.72 5.653333 19.52 7.125333 8.042667 17.514667 13.781333 31.381334 17.578667 6.741333 1.834667 11.861333 2.922667 19.370666 3.84l8.469334 0.896 23.274666 1.941333 18.154667 0.426667 2.688 0.149333 21.546667 1.770667 8.896 0.917333c11.477333 1.365333 22.016 3.264 32.277333 6.08 24.938667 6.848 46.037333 18.496 62.293333 36.778667 16 17.962667 23.466667 41.194667 21.589334 66.581333-1.706667 24.256-12.778667 48.341333-29.312 64.618667-25.429333 25.024-59.989333 39.872-98.389334 44.906667v76.629333h-64v-76.992a200.405333 200.405333 0 0 1-119.722666-63.488l47.466666-42.922667c23.317333 25.770667 56.448 41.898667 93.013334 44.309334 40.042667 2.666667 75.733333-7.381333 96.746666-28.074667 5.397333-5.312 9.728-14.762667 10.368-23.594667 0.64-8.554667-1.344-14.677333-5.589333-19.456-7.146667-8.042667-17.536-13.76-31.402667-17.578666a127.445333 127.445333 0 0 0-22.485333-4.202667l-9.045333-0.874667-19.626667-1.621333-18.176-0.405333-2.666667-0.170667-12.053333-0.981333-13.994667-1.216-4.373333-0.469334a216.661333 216.661333 0 0 1-32.234667-6.08c-24.96-6.826667-46.08-18.496-62.293333-36.736-16-17.941333-23.466667-41.152-21.653333-66.645333 1.706667-24.234667 12.8-48.32 29.333333-64.576 25.386667-25.045333 59.989333-39.893333 98.410667-44.949333v-76.608h64z"></path>
                </svg>
                <b style={{ marginLeft: "8px" }}>
                  {dashboardTranslation?.invoices
                    ? dashboardTranslation?.invoices
                    : "Invoices"}
                </b>
              </div>
              <div
                onClick={() => history.push("/customer-account/invoice")}
                className=" pointer-cursor"
              >
                <img
                  className="img-color"
                  src={arrow}
                  style={{ height: "15px", width: "15px" }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
